
import { Lightbulb, Users, Briefcase, Plus } from "lucide-react";
import { Asterisk } from "@/components/Asterisk";
import { Footer } from "@/components/Footer";
import { HowToWorkWithMe } from "@/components/HowToWorkWithMe";
import { BlogSection } from "@/components/blog/BlogSection";

const Index = () => {
  const services = [{
    title: "Coaching",
    icon: <Users className="w-10 h-10" />,
    items: [{
      label: "STRATEGIC SPARRING PARTNER",
      route: "/strategic-sparring-partner"
    }]
  }, {
    title: "Speaking",
    icon: <Briefcase className="w-10 h-10" />,
    items: [{
      label: "SPEAKING ENGAGEMENTS",
      route: "/speaking"
    }]
  }];

  return <main className="min-h-screen bg-white">
      <nav className="flex justify-between items-center px-10 py-6">
        <h2 className="text-2xl font-groteks tracking-tight">HG</h2>
      </nav>

      <section className="max-w-6xl mx-auto px-4 pt-20 pb-12">
        <div className="flex flex-col items-center text-center mb-16">
          <h1 className="text-[80px] md:text-[155px] leading-[1] tracking-[-0.02em] font-groteks font-normal mb-4">I'm Hiba — a X in Residence.</h1>
        </div>

        <div className="flex flex-col md:flex-row gap-12 items-center">
          <div className="w-full md:w-1/2">
            <h2 className="text-[30px] md:text-[62px] leading-tight font-medium mb-8">
              I've done lots of product work.
            </h2>
            <div className="space-y-6 text-xl md:text-[22px] font-inter">
              <p>
                Including but not limited to venture building, brand strategy, community engagement, proof of concept app building and UX design.
              </p>
              <p>That's what I mean by X in Residence (XIR).</p>
              <p>
                I like to work fast and not faff around. I also like to work with the resources at hand. It's because I like to get to the core problem to solve and unblock the system bit by bit. I like building things and showing you rather than telling you.
              </p>
              <p>At the moment, I lead product at the kyu Collective. I've worked with startups, corporates, artists - you name it. I've gotten to work with and shape some pretty incredible brands through my product and strategy work.</p>
            </div>
          </div>
          <div className="w-full md:w-1/2">
            <img src="/lovable-uploads/245c62c3-ca9d-4e2e-94bb-04d066a6ea71.png" alt="Professional headshot in an office setting" className="w-full rounded-lg object-cover" />
          </div>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-4 py-16">
        <div className="flex items-end">
          <h2 className="text-[40px] leading-[0.95] font-groteks font-medium md:text-6xl">
            WRITING
          </h2>
        </div>
        
        <div className="mt-14 space-y-4">
          <button onClick={() => window.open('https://hibag.substack.com', '_blank')} className="w-full text-left px-10 py-[34px] bg-white border-2 border-black rounded-[32px] hover:bg-gray-50 transition-colors duration-200 flex items-center gap-2 group">
            <Plus className="w-10 h-10" />
            <span className="text-[38px] leading-[1.16] font-medium">
              GO TO MY SUBSTACK
            </span>
            <span className="ml-auto opacity-0 group-hover:opacity-100 transition-opacity duration-200 text-2xl">
              →
            </span>
          </button>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-4">
        <HowToWorkWithMe services={services} />
      </section>
      <Asterisk />
      <Footer />
    </main>;
};

export default Index;
